import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  filters: {
    formData: {
      modelCreator: '',
      l1: '',
      l2: '',
      l3: '',
      vendor: '',
    },
    searchText: '',
    pageNumber: 0,
  },
  previouslySelectedRow: null,
}

export const skuFiltersSlice = createSlice({
  name: 'sku-filters',
  initialState,
  reducers: {
    setSkuFilterValues: (state, action) => {
      state.filters = action.payload
    },
    clearSkuFilters: () => initialState,
    setPreviouslySelectedRow: (state, action) => {
      state.previouslySelectedRow = action.payload
    },
  },
})

export const { setSkuFilterValues, clearSkuFilters, setPreviouslySelectedRow } =
  skuFiltersSlice.actions

export default skuFiltersSlice.reducer
